export const GATE_MEDIA = {
  'mlzna-brana-gate': '/media/gates/gate-u.webp',
  'brana-bendy': '/media/gates/steblo-gate-1.webp',
  'linea-gate': '/media/gates/linea-gate.webp',
  'mlzitko-kruh': '/media/gates/kruh.webp',
};
export const STEBLO_GATE_PHOTOS = [1, 2, 3].map(index => `/media/gates/steblo-gate-${index}.webp`);
